import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';
import { FileCheck, Save, ChevronDown, ChevronUp, ExternalLink } from 'lucide-react';

const PAGES = [
  { slug: 'terms', label: 'Termini e Condizioni', hint: 'Solo utenti loggati (Profilo)' },
  { slug: 'privacy', label: 'Privacy Policy', hint: 'Footer login' },
  { slug: 'cookies', label: 'Cookie Policy', hint: 'Footer login' },
  { slug: 'antifraud', label: 'Anti-Fraud Policy', hint: 'Footer login' },
  { slug: 'dmca', label: 'DMCA / Copyright', hint: 'Solo utenti loggati (Profilo)' },
];

export default function AdminLegalPage() {
  const [pages, setPages] = useState({});
  const [urls, setUrls] = useState({});
  const [expanded, setExpanded] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const results = {};
        for (const p of PAGES) {
          try { const { data } = await api.get(`/legal/${p.slug}`); results[p.slug] = data.page; }
          catch (e) { results[p.slug] = { title_it: '', title_en: '', content_it: '', content_en: '', version: '1.0' }; }
        }
        setPages(results);
        const { data: settings } = await api.get('/admin/settings');
        const u = {};
        PAGES.forEach(p => { u[p.slug] = settings?.general?.[`legal_url_${p.slug}`] || ''; });
        setUrls(u);
      } catch (e) {} finally { setLoading(false); }
    })();
  }, []);

  const save = async (slug) => {
    try {
      await api.put(`/legal/${slug}`, pages[slug]);
      await api.put('/admin/settings', { settings: { [`legal_url_${slug}`]: urls[slug] || '' } });
      toast.success('Pagina aggiornata!');
    } catch (err) { toast.error('Errore'); }
  };

  const set = (slug, k, v) => setPages(p => ({ ...p, [slug]: { ...p[slug], [k]: v } }));

  if (loading) return <div className="flex justify-center py-20"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-yellow-400" /></div>;

  return (
    <div className="max-w-4xl">
      <h1 className="text-2xl font-bold text-white mb-6 flex items-center gap-2"><FileCheck size={24} className="text-yellow-400" />Pagine Legali</h1>
      <p className="text-xs text-gray-500 mb-4">Per ogni pagina puoi inserire un URL esterno (es. proudnoize.com/privacy) oppure scrivere il contenuto qui.</p>
      <div className="space-y-4">
        {PAGES.map(p => (
          <div key={p.slug} className="card-dark overflow-hidden">
            <button className="w-full flex items-center justify-between p-4 hover:bg-gray-800 transition" onClick={() => setExpanded(expanded === p.slug ? null : p.slug)}>
              <div className="flex items-center gap-2">
                <span className="font-medium text-white">{p.label}</span>
                {pages[p.slug]?.version && <span className="text-xs text-gray-500">v{pages[p.slug].version}</span>}
                {urls[p.slug] && <span className="text-xs text-green-400 flex items-center gap-1"><ExternalLink size={10} />URL</span>}
              </div>
              <div className="flex items-center gap-2">
                <span className="text-[10px] text-gray-600">{p.hint}</span>
                {expanded === p.slug ? <ChevronUp size={16} className="text-gray-400" /> : <ChevronDown size={16} className="text-gray-400" />}
              </div>
            </button>
            {expanded === p.slug && (
              <div className="p-4 border-t border-gray-700 space-y-4">
                <div className="bg-gray-800/50 p-3 rounded-lg">
                  <label className="block text-xs text-yellow-400 mb-1 flex items-center gap-1"><ExternalLink size={12} />URL Esterno (opzionale)</label>
                  <input className="input-field-dark" value={urls[p.slug] || ''} onChange={e => setUrls(u => ({ ...u, [p.slug]: e.target.value }))} placeholder="https://proudnoize.com/privacy" />
                  <p className="text-[10px] text-gray-500 mt-1">Se compilato, il link va a questo URL invece del contenuto sotto</p>
                </div>
                <div className={urls[p.slug] ? 'opacity-40' : ''}>
                  <div className="grid grid-cols-2 gap-4">
                    <div><label className="block text-xs text-gray-400 mb-1">Titolo IT</label><input className="input-field-dark" value={pages[p.slug]?.title_it || ''} onChange={e => set(p.slug, 'title_it', e.target.value)} /></div>
                    <div><label className="block text-xs text-gray-400 mb-1">Titolo EN</label><input className="input-field-dark" value={pages[p.slug]?.title_en || ''} onChange={e => set(p.slug, 'title_en', e.target.value)} /></div>
                  </div>
                  <div className="mt-3"><label className="block text-xs text-gray-400 mb-1">Contenuto IT (HTML)</label><textarea className="input-field-dark h-48 resize-y font-mono text-xs" value={pages[p.slug]?.content_it || ''} onChange={e => set(p.slug, 'content_it', e.target.value)} /></div>
                  <div className="mt-3"><label className="block text-xs text-gray-400 mb-1">Contenuto EN (HTML)</label><textarea className="input-field-dark h-48 resize-y font-mono text-xs" value={pages[p.slug]?.content_en || ''} onChange={e => set(p.slug, 'content_en', e.target.value)} /></div>
                </div>
                <button onClick={() => save(p.slug)} className="btn-admin inline-flex items-center gap-2"><Save size={16} />Salva {p.label}</button>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
